import { ActionTypes } from './actions/types';
import { stateType }   from './types/reducer';

const initialState: stateType = {
  appsArray:       [],
  userLogedIn:     '',
  userName:        '',
  userEmail:       '',
  userRole:        '',
  teacherId:       -1,
  studentsInfo:    [],
  badTeacherError: false,
};

const reducer = (state = initialState, action: ActionTypes) => {

  switch (action.type) {

//SET_APPS        -      -      -      -      -      -      -      -      -      -      -      -



case 'SET_APPS':
      {
        return {
          ...state,
          appsArray: action.payload
        }

      }



//SET_USER_INFO   -      -      -      -      -      -      -      -      -      -      -      -



    case 'SET_USER_INFO':
      {

        const { userName, userEmail, teacherId, userRole, userLogedIn } = action.payload;
        return {
          ...state,
          userLogedIn: userLogedIn,
          userName:    userName,
          userEmail:   userEmail,
          userRole:    userRole,
          teacherId:   teacherId
        }

      }


//SET_STUENTS_INFO   -      -      -      -      -      -      -      -      -      -      -      -


    
    case 'SET_STUDENTS_INFO':
      {
        return {
          ...state,
          studentsInfo: action.payload
        }
  
      }



//SET_BAD_TEACHER_ID / HIDE_TEACHER_ERROR / SET_NEW_TEACHER_ID -      -      -      -      -      -      -      -      -      -      -      -


    
    case 'SET_BAD_TEACHER_ID':
      {
        return {
          ...state,
          badTeacherError: true
        }
      }
            
      case 'HIDE_TEACHER_ERROR':
      {
        return {
          ...state,
          badTeacherError: false
        }
      }

      case 'SET_NEW_TEACHER_ID':
      {
        return {
          ...state,
          teacherId: action.payload
        }
      }

     


// -      -      -      -      -      -      -      -      -      -      -      -

    default: return state;
  }
};

export type reducerType = ReturnType<typeof reducer>;

export { reducer };
